module.exports = __webpack_public_path__ + "img/lottery_460.1b673eb1.png";